import { buildNotificationForContactVolunteer } from '@/backend/features/background-check/platform-functions/utils';
import { getExtendedAccountStorage } from '@/backend/features/contact-management/utils/getExtendedAccountStorage';
import { requireManageMembersAndAnySystemPermission } from '@/backend/utils';
import { AuthError, UserContext } from '@juvare/platform-app/App';
import { AppState, UserState } from '@juvare/platform-sdk-react/types';

export interface ContactVolunteerParams {
    accountId: string;
    missingProfileInformation: string[];
}

export const contactVolunteer = (
    context: UserContext<AppState, UserState>,
    { accountId, missingProfileInformation }: ContactVolunteerParams,
) => {
    if (!requireManageMembersAndAnySystemPermission(context.userState, 'request-background-check')) {
        throw new AuthError('Unauthorized');
    }

    const volunteerNotifications = buildNotificationForContactVolunteer({
        context,
        accountId,
        missingProfileInformation,
    });

    if (volunteerNotifications.length > 0) {
        context.notifyService.postNotification(volunteerNotifications);

        const accountStorage = getExtendedAccountStorage(context);

        accountStorage.post({
            action: 'partial-update',
            id: accountId,
            data: {
                lastContactedAt: Date.now(),
            },
        });
    }
};
